import { graphql } from "gql";

const ADMIN_EDIT_TAG_CATEGORY_MUTATION = graphql(`
  mutation AdminEditTagCategory($id: ID!, $input: AdminEditTagCategoryInput!) {
    adminEditTagCategory(id: $id, input: $input) {
      ...TagCategory
    }
  }
`);

export default ADMIN_EDIT_TAG_CATEGORY_MUTATION;
